<template>
    <SchedulerSubtaskList></SchedulerSubtaskList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SchedulerSubtaskList = defineAsyncComponent(() =>
    import("../../components/Design/SchedulerSubTaskList.vue")
);

export default {
    name: "SchedulerPage", //The name you are in should not equal the name of the component you are importing.
    components: { SchedulerSubtaskList, AuthLayout },
};
</script>
